import React from 'react';
import { Phone, Send, Zap, Shield, Award } from 'lucide-react';
import { Button } from '../ui/button';

export const CTA = () => {
  return (
    <section data-testid="cta-section" className="py-20 bg-gradient-to-br from-[#0066FF] to-[#00D9FF] relative overflow-hidden">
      <div className="absolute inset-0 opacity-20">
        <div className="absolute inset-0" style={{ backgroundImage: 'repeating-linear-gradient(45deg, transparent, transparent 35px, rgba(255,255,255,.1) 35px, rgba(255,255,255,.1) 70px)' }} />
      </div>
      <div className="container mx-auto px-4 text-center relative z-10">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-6">
            Ready to Keep Your Property Comfortable Year-Round?
          </h2>
          <p className="text-base md:text-lg text-blue-50 mb-4">
            Whether you need an emergency repair or want to discuss a maintenance contract – we're here to help.
          </p>
          <p className="text-base text-blue-100 mb-10">
            <strong>Homeowners:</strong> Get fast, reliable service. <strong>Businesses:</strong> Protect your investment with preventative maintenance.
          </p>

          <div className="flex flex-col sm:flex-row justify-center gap-4 mb-8">
            <Button size="lg" className="bg-[#0A0E27] text-white hover:bg-[#111640] text-lg px-10 py-7 rounded-xl shadow-2xl font-bold transform hover:scale-105 transition-all" data-testid="cta-call-btn">
              <a href="tel:0644505026" className="flex items-center space-x-3">
                <Phone className="w-5 h-5" />
                <span>Call: 064 450 5026</span>
              </a>
            </Button>
            <Button size="lg" className="bg-white/20 border border-white/30 text-white hover:bg-white/30 text-lg px-10 py-7 rounded-xl backdrop-blur-sm font-bold transform hover:scale-105 transition-all" data-testid="cta-whatsapp-btn">
              <a href="https://wa.me/27644505026?text=Hi%2C%20I%27d%20like%20to%20book%20a%20service%20with%20Chill%20Point" target="_blank" rel="noopener noreferrer" className="flex items-center space-x-3">
                <Send className="w-5 h-5" />
                <span>WhatsApp Us</span>
              </a>
            </Button>
          </div>

          <div className="flex flex-wrap justify-center gap-6 text-sm">
            {[
              { icon: <Zap className="w-4 h-4 text-yellow-300" />, text: 'Same-Day Service Available' },
              { icon: <Shield className="w-4 h-4" />, text: 'Heating & Cooling' },
              { icon: <Award className="w-4 h-4" />, text: '5-Star Rated' },
            ].map((item, i) => (
              <div key={i} className="flex items-center space-x-2 text-white font-semibold">
                {item.icon}
                <span>{item.text}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
